export default __webpack_public_path__ + "static/media/shope.79eb577e.png";